import { makeStyles } from "@material-ui/styles";
import React from "react";
import datadogLogo from "../../../media/images/datadog.png";
import honeybadgerLogo from "../../../media/images/honeybadger.jpg";
import opsgenieLogo from "../../../media/images/opsgenie.png";
import kajabiLogo from "../../../media/images/kajabi.png";
import jiraLogo from "../../../media/images/jira.png";
import { Vendor } from "@internal/plugin-ops-review-common";

const useStyles = makeStyles(() => ({
  logo: {
    width: 48,
    height: 48,
    borderRadius: "5px",
    position: "relative",
    top: "10px",
    marginRight: "20px",
    display: "inline",
    background: "white",
  },
}));

export interface Props {
  vendor: Vendor;
}

export const VendorLogo: React.FC<Props> = ({ vendor }): JSX.Element => {
  const classes = useStyles();

  let image;
  let alt;

  switch (vendor) {
    case "datadog":
      image = datadogLogo;
      alt = "Datadog";
      break;
    case "honeybadger":
      image = honeybadgerLogo;
      alt = "Honeybadger";
      break;
    case "opsgenie":
      image = opsgenieLogo;
      alt = "OpsGenie";
      break;
    case "kajabi":
      image = kajabiLogo;
      alt = "Kajabi";
      break;
    case "jira":
      image = jiraLogo;
      alt = "Jira";
      break;
    default:
      image = datadogLogo;
      alt = "Datadog";
  }

  return <img src={image} alt={alt} className={classes.logo} title={alt} />;
};
